<template>
  <Card class="layout-card" style="height: 100%">
    <div class="header-container">
      <div class="search-form">
        <Select
          v-model="searchForm.popupType"
          placeholder="弹窗类型"
          clearable
          style="width: 150px"
        >
          <Option :value="1">折扣弹窗</Option>
          <Option :value="2">剧集推荐弹窗</Option>
          <Option :value="3">登录弹窗</Option>
          <Option :value="4">观看激励视频弹窗</Option>
          <Option :value="5">自定义弹窗</Option>
          <Option :value="6">通知弹窗</Option>
        </Select>
        <Select
          v-model="searchForm.deviceSys"
          placeholder="操作系统"
          clearable
          style="width: 150px"
        >
          <Option :value="0">iOS</Option>
          <Option :value="1">Android</Option>
          <Option :value="-1">通用</Option>
        </Select>
        <Select
          v-model="searchForm.popupStatus"
          placeholder="弹窗状态"
          clearable
          style="width: 150px"
        >
          <Option :value="1">开启</Option>
          <Option :value="0">关闭</Option>
        </Select>
        <Input
          v-model="searchForm.popupName"
          placeholder="请输入弹窗备注"
          clearable
          style="width: 250px"
        />
        <Button type="primary" @click="getData(1)">搜索</Button>
      </div>
      <div>
        <Button type="success" icon="md-add" @click="handleOpenEditModal()"
          >新增弹窗</Button
        >
      </div>
    </div>

    <div class="table-container">
      <Table :data="tableData" :columns="columns" :loading="tableLoading" row-key="id">
        <template #status="{ row }">
          <i-switch
            :key="row.id + '_' + renderKey"
            :value="Number(row.popupStatus)"
            :true-value="1"
            :false-value="0"
            :disabled="tableLoading || Boolean(statusChangingId)"
            :loading="statusChangingId === row.id"
            @on-change="(val) => handleStatusChange(row, val)"
          />
        </template>
        <template #action="{ row }">
          <div class="action-buttons">
            <a @click="handleView(row)">查看</a>
            <a @click="handleOpenEditModal(row)">修改</a>
            <a @click="handleDelete(row)">删除</a>
          </div>
        </template>
        <template #footer>
          <Pages :page="page" :func="getData"></Pages>
        </template>
      </Table>
    </div>

    <EditModal
      v-model="editVisible"
      :data="editForm"
      :readonly="editReadonly"
      @on-success="getData"
    />
  </Card>
</template>

<script>
import Pages from '@/components/pages'
import EditModal from './components/EditModal.vue'
import {
  getPopupList,
  changePopupStatus,
  delPopup,
  getPopupInfo
} from '@/api/popup'

export default {
  name: 'NotificationList',
  components: {
    Pages,
    EditModal
  },
  data() {
    return {
      renderKey: 0,
      searchForm: {
        popupType: '',
        deviceSys: '',
        popupStatus: '',
        popupName: ''
      },
      tableLoading: false,
      statusChangingId: '',
      editVisible: false,
      editReadonly: false,
      editForm: {},
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      tableData: [],
      columns: [
        {
          title: '弹窗备注名称',
          key: 'popupName',
          minWidth: 200
        },
        {
          title: '弹窗类型',
          key: 'popupType',
          minWidth: 120,
          render: (h, params) => {
            const types = {
              1: '折扣弹窗',
              2: '剧集推荐弹窗',
              3: '登录弹窗',
              4: '观看激励视频弹窗',
              5: '自定义弹窗',
              6: '通知弹窗'
            }
            return h('span', types[params.row.popupType] || '未知')
          }
        },
        {
          title: '操作系统',
          key: 'deviceSys',
          minWidth: 100,
          render: (h, params) => {
            const systems = {
              0: 'iOS',
              1: 'Android',
              '-1': '通用'
            }
            return h('span', systems[params.row.deviceSys] || '未知')
          }
        },
        {
          title: '发布时间',
          key: 'createTime',
          minWidth: 180
        },
        {
          title: '弹窗状态',
          slot: 'status',
          width: 120,
          align: 'center'
        },
        {
          title: '操作',
          slot: 'action',
          width: 250,
          align: 'center'
        }
      ]
    }
  },
  methods: {
    async getData(current) {
      if (current) this.page.current = current
      this.tableLoading = true
      try {
        const params = {
          current: this.page.current,
          size: this.page.size,
          ...this.searchForm
        }
        const { data } = await getPopupList(params)
        this.tableData = data.records || []
        this.page.total = data.total || 0
        this.renderKey++
      } catch (error) {
        this.$Message.error('获取列表失败')
      } finally {
        this.tableLoading = false
      }
    },
    async handleOpenEditModal(row) {
      if (row) {
        try {
          this.tableLoading = true // Optional: show loading on table or use a separate loading state
          const { data } = await getPopupInfo(row.id)
          this.editForm = data
          this.editReadonly = false
          this.editVisible = true
        } catch (error) {
          this.$Message.error('获取详情失败')
        } finally {
          this.tableLoading = false
        }
      } else {
        this.editForm = {}
        this.editReadonly = false
        this.editVisible = true
      }
    },
    async handleStatusChange(row, val) {
      if (this.tableLoading || this.statusChangingId) return

      const previousStatus = Number(row.popupStatus)
      const nextStatus = Number(val)
      if (previousStatus === nextStatus) return

      this.statusChangingId = row.id
      // 先让行数据与开关保持一致，请求失败时回滚，
      // 避免出现“开关已打开但后台没有生效”的假状态
      this.$set(row, 'popupStatus', nextStatus)

      try {
        await changePopupStatus(row.id)
        this.$Message.success(`状态已切换至: ${nextStatus ? '开启' : '关闭'}`)
        await this.getData()
      } catch (error) {
        this.$set(row, 'popupStatus', previousStatus)
        this.$Message.error('操作失败')
      } finally {
        this.statusChangingId = ''
      }
    },
    handleDelete(row) {
      this.$Modal.confirm({
        title: '提示',
        content: `是否确定删除该弹窗: "${row.popupName}"?`,
        onOk: async () => {
          try {
            await delPopup(row.id)
            this.$Message.success('删除成功')
            this.getData()
          } catch (error) {
            this.$Message.error('删除失败')
          }
        }
      })
    },
    async handleView(row) {
      try {
        this.tableLoading = true
        const { data } = await getPopupInfo(row.id)
        this.editForm = data
        this.editReadonly = true
        this.editVisible = true
      } catch (error) {
        this.$Message.error('获取详情失败')
      } finally {
        this.tableLoading = false
      }
    },
    handlePushTest(row) {
      this.$Message.info('推送测试: ' + row.popupName)
    }
  },
  mounted() {
    this.getData()
  }
}
</script>

<style scoped lang="less">
.header-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 10px;
}

.search-form {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.table-container {
  flex: 1;
  overflow: auto;
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 15px;

  a {
    color: #2d8cf0;
    &:hover {
      color: #57a3f3;
    }
  }
}

.layout-card {
  display: flex;
  flex-direction: column;
  /deep/ .ivu-card-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 20px;
  }
}
</style>
